export enum LocalStorageKeys {
    APP_CONFIG = 'appConfig',
    LOCALE = 'LOCALE',
    OIDC_OAUTH_TOKEN = 'OAUTH_TOKEN',
    REDIRECTION = 'REDIRECTION',
    SESSION_COOKIE = 'SESSION_COOKIE',
    SECONDARY_ACCESS_TOKEN = "SECONDARY_ACCESS_TOKEN"
}
